// extracted by mini-css-extract-plugin
module.exports = {"pageGroup":"_2YGAo"};